import { jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import styled from "@mui/material/styles/styled";
import Typography from "../Typography";
import isEmpty from "lodash/isEmpty";
import isArray from "lodash/isArray";
const ColoredSpan = styled("span")(({ theme, bg }) => {
  return {
    backgroundColor: theme.palette[bg].main,
    color: theme.palette[bg].contrast
  };
});
const HighlightedTypography = (props) => {
  const { content, children, highlights, bg = "success", ...rest } = props;
  if (!highlights || !isArray(highlights) || isEmpty(highlights)) {
    return /* @__PURE__ */ jsx(Typography, { ...rest, children: content ?? children });
  }
  const splittedText = useMemo(() => {
    let currentPosition = 0;
    const result = [];
    highlights.forEach((highlight) => {
      const { start, end } = highlight;
      if (currentPosition < start) {
        result.push(
          /* @__PURE__ */ jsx("span", { children: content.slice(currentPosition, start) }, `text-${currentPosition}`)
        );
      }
      result.push(
        /* @__PURE__ */ jsx(ColoredSpan, { bg, children: content.slice(start, end) }, `highlight-${start}-${end}`)
      );
      currentPosition = end;
    });
    if (currentPosition < content.length) {
      result.push(
        /* @__PURE__ */ jsx("span", { children: content.slice(currentPosition) }, `text-${currentPosition}`)
      );
    }
    return result;
  }, [content, highlights, bg]);
  return /* @__PURE__ */ jsx(Typography, { ...rest, children: splittedText });
};
var HighlightedTypography_default = HighlightedTypography;
export {
  HighlightedTypography_default as default
};
